import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Message {
  id: string
  content: string
  sender_id: string
  channel_id: string
  created_at: string
  updated_at: string
  reactions?: Record<string, string[]>
}

interface Channel {
  id: string
  name: string
  server_id: string
  description?: string
  type: 'text' | 'voice'
}

interface Server {
  id: string
  name: string
  icon_url?: string
  owner_id: string
}

interface MessagingState {
  servers: Server[]
  channels: Channel[]
  messages: Message[]
  activeServerId: string | null
  activeChannelId: string | null
  loading: boolean
  error: string | null
}

const initialState: MessagingState = {
  servers: [],
  channels: [],
  messages: [],
  activeServerId: null,
  activeChannelId: null,
  loading: false,
  error: null,
}

const messagingSlice = createSlice({
  name: 'messaging',
  initialState,
  reducers: {
    setServers: (state, action: PayloadAction<Server[]>) => {
      state.servers = action.payload
    },
    setChannels: (state, action: PayloadAction<Channel[]>) => {
      state.channels = action.payload
    },
    setMessages: (state, action: PayloadAction<Message[]>) => {
      state.messages = action.payload
    },
    messagesLoaded: (state, action: PayloadAction<Message[]>) => {
      state.messages = action.payload
    },
    addMessage: (state, action: PayloadAction<Message>) => {
      state.messages.push(action.payload)
    },
    setActiveServer: (state, action: PayloadAction<string>) => {
      state.activeServerId = action.payload
    },
    setActiveChannel: (state, action: PayloadAction<string>) => {
      state.activeChannelId = action.payload
    },
    setCurrentChannel: (state, action: PayloadAction<string>) => {
      state.activeChannelId = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
  },
})

export const {
  setServers,
  setChannels,
  setMessages,
  messagesLoaded,
  addMessage,
  setActiveServer,
  setActiveChannel,
  setCurrentChannel,
  setLoading,
  setError,
} = messagingSlice.actions

export default messagingSlice.reducer
